import { TenderListResponse } from '../types/tender';

/**
 * Service for fetching tenders/contracts from the API
 */
class TenderService {
  private baseUrl: string;

  constructor() {
    // Use current origin to support both dev and production environments
    this.baseUrl = window.location.origin;
    console.log(`[TENDER_SERVICE] Initialized with baseUrl: ${this.baseUrl}`);
  }

  /**
   * Fetch tenders for a specific company
   * @param companyName - Company name to fetch tenders for
   * @param search - Optional search query for filtering by title
   * @param limit - Maximum number of results (default: 50)
   * @param paginationToken - Optional pagination token for fetching next page
   * @returns Promise resolving to tender list response
   */
  async getTendersForCompany(
    companyName: string,
    search?: string,
    limit: number = 50,
    paginationToken?: string
  ): Promise<TenderListResponse> {
    console.log(`[TENDER_SERVICE] Fetching tenders for company: ${companyName}`);
    console.log(`[TENDER_SERVICE] Parameters:`, { search, limit, hasToken: !!paginationToken });

    try {
      // Build query parameters
      const params = new URLSearchParams({
        companyName,
        limit: limit.toString()
      });

      if (search && search.trim()) {
        params.append('search', search.trim());
      }

      if (paginationToken) {
        params.append('token', paginationToken);
      }

      const url = `${this.baseUrl}/api/outlook/tenders?${params.toString()}`;
      console.log(`[TENDER_SERVICE] Request URL: ${url}`);

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(
          errorData.message || `HTTP ${response.status}: ${response.statusText}`
        );
      }

      const result: TenderListResponse = await response.json();
      console.log(`[TENDER_SERVICE] Successfully fetched ${result.data.contracts.length} tenders`);
      console.log(`[TENDER_SERVICE] Has more pages: ${result.data.lastEvaluatedKey ? 'Yes' : 'No'}`);

      return result;

    } catch (error) {
      console.error(`[TENDER_SERVICE] Error fetching tenders:`, error);
      throw error;
    }
  }
}

// Export singleton instance
export const tenderService = new TenderService();
export default tenderService;
